module.exports = __webpack_public_path__ + "static/media/logo8.629a98ad.jpg";